
import { required } from 'vuelidate/lib/validators'

export default function () {
  /** se exitir vagas para visitantes */
  if (this.user.parking_space_for_visitors === true) {
    return {
      parking: {
        plate: {
          required
        },
        model: {
          required
        },
        color: {
          required
        },
        garage_number_visitor: {
          required
        },
        tower_id: {
          required
        },
        unit_id: {
          required
        },
        guest_name: {
          required
        },
        destination_tower_id: {
          required
        },
        destination_unit_id: {
          required
        },
        date_go_in: {
          required
        },
        date_go_out: {
          required
        }
      }
    }
  } else {
    return {
      parking: {
        plate: {
          required
        },
        model: {
          required
        },
        color: {
          required
        },
        tower_id: {
          required
        },
        unit_id: {
          required
        },
        garage_id: {
          required
        },
        guest_name: {
          required
        },
        destination_tower_id: {
          required
        },
        destination_unit_id: {
          required
        },
        date_go_in: {
          required
        },
        date_go_out: {
          required
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/parking/form/resources/validations.js